import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';


// Debug: Log environment variables (remove in production)
console.log('Firebase Config Debug:', {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ? 'Present' : 'Missing',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID ? 'Present' : 'Missing'
});

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Check if Firebase should be initialized (for development)
const shouldInitializeFirebase = () => {
  // Check if we're in development and have placeholder values
  const isDevelopment = process.env.NODE_ENV === 'development';
  const hasPlaceholders = firebaseConfig.apiKey === 'your_firebase_api_key_here' || 
                          firebaseConfig.projectId === 'your-project-id';
  
  // Only initialize if we have real values OR if we're in production
  return !hasPlaceholders || !isDevelopment;
};

// Initialize Firebase conditionally
let app;
let db;

if (shouldInitializeFirebase() && firebaseConfig.projectId && firebaseConfig.apiKey) {
  try {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    console.log('Firebase initialized successfully with project:', firebaseConfig.projectId);
  } catch (error) {
    console.error('Firebase initialization failed:', error);
    console.warn('Firebase features will not be available');
  }
} else {
  console.warn('Firebase not initialized - missing configuration or using placeholders');
  console.warn('Firebase-dependent features will not be available');
  
  // Create mock objects for development
  db = null;
  app = null;
}

export { db };

export default app;